import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
	connectionsProblem: {
		id: 'websocketError.problemWithConnection',
		defaultMessage: 'Проблемы с соединением.',
	},
	reconnecting: {
		id: 'websocketError.reconnecting',
		defaultMessage: 'Переподключение',
	},
});
